"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CarListingOffer {
    constructor(bodyType, colors, displayName, makeName, makeSlug, modelFullName, modelName, modelSlug, order, simpleOfferList, topEquipmentLabels) {
        this.bodyType = bodyType;
        this.colors = colors;
        this.displayName = displayName;
        this.makeSlug = makeSlug;
        this.makeName = makeName;
        this.modelFullName = modelFullName;
        this.modelName = modelName;
        this.modelSlug = modelSlug;
        this.order = order;
        this.simpleOfferList = simpleOfferList;
        this.topEquipmentLabels = topEquipmentLabels;
    }
}
exports.default = CarListingOffer;
